module.exports = __webpack_public_path__ + "static/img/home_banner_3.317d686.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home_banner_3.jpg
// module id = h2Xv
// module chunks = 1